const REGIONS = ['South', 'Carolinas'];

export default REGIONS;
